var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import isEqual from 'lodash/isEqual';
import { env } from '@repo/env';
import { ApiClient, apiPaths, useApiErrorStoreActions } from '@repo/api/client';
import { loanSuccessResponseBody } from './loan-get.schema';
var apiEndpoint = apiPaths.loan;
function getSingleLoan(params) {
    var loanId = params.loanId, restParams = __rest(params, ["loanId"]);
    var parsedParams = __assign({}, restParams);
    var searchParams = new URLSearchParams(parsedParams);
    return ApiClient.fetch("".concat(apiEndpoint.path, "/").concat(loanId, "?").concat(searchParams.toString()), {
        options: { method: 'GET' },
        successSchema: loanSuccessResponseBody,
    });
}
var refetchInterval = env.VITE_POLLING_INTERVAL ? parseInt(env.VITE_POLLING_INTERVAL, 10) : 10000;
export function useGetLoan(isEnabled) {
    var _a = useState(null), params = _a[0], setParams = _a[1];
    var setApiError = useApiErrorStoreActions().setApiError;
    var query = useQuery({
        queryKey: ['get-loan', params],
        queryFn: function () { return (params ? getSingleLoan(params) : Promise.resolve(null)); },
        enabled: Boolean(params) && isEnabled,
        refetchOnWindowFocus: false,
        retry: false,
        refetchInterval: isEnabled ? refetchInterval : false,
        throwOnError: function (error) {
            setApiError({
                apiPathId: apiEndpoint.id,
                error: error,
            });
            return false;
        },
    });
    var customRefetch = function (newParams) {
        if (!isEqual(newParams, params)) {
            setParams(newParams);
            void query.refetch();
        }
    };
    return Object.assign({}, query, { refetch: customRefetch });
}
